import { useEffect } from 'react';
import LogoContainer from '../../components/header/LogoContainer';
import { useLocation, useNavigate } from 'react-router-dom';

function EditProfile(props) {
  const { state } = useLocation();
  const profileUrl = state?.profileUrl;

  const navigate = useNavigate();
  useEffect(() => {
    window.addEventListener('message', ({ data }) => {
      if (data && data.action === 'submission-completed') {
        setTimeout(() => {
          navigate(-2);
        }, 2000);
      }
    });
  }, []);

  return (
    <div style={{ height: '100%' }}>
      <LogoContainer title="Profile" />
      <iframe
        title="Profile"
        style={{ width: '100%', height: '100%' }}
        src={profileUrl}
        id="iframe_id"
        frameBorder="0"
        allowFullScreen />
    </div>

  );
};

export default EditProfile;
